<template>
    <div></div>
</template>
<script>
import {getAuthInfo } from '@api/index'
import { onMounted, getCurrentInstance } from 'vue'
import {useRouter} from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
export default {
    setup () {
        const router = useRouter()
        const loading = useLoading()
        const proxy = getCurrentInstance().proxy
        let verifyArray = []
        const  reflect = {
            "basic":"basic",
            "work" : "work",
            "identity": "kycAadhaarAndPan",
            "face":"kycFaceAndHold",
            "contacts":"contact"
        }
        const route = router.currentRoute
        onMounted( async ()=> {
            const loader = loading.show({
                container: null
            })
            // const products = await index()
            
            // let prodcut_ids = products.data.homeProductVos.filter(element => {
            //     return element.productStatus == 1
            // }).map(element=>{
            //     return element.id
            // })

            const data = await getAuthInfo()            
            if(data.code == 0){
                verifyArray = data.data.userAuthConfigVoList
                loader.hide()
                let compelete = true
                for(let i = 0; i< verifyArray.length;i++){
                    let target = verifyArray[i]
                    let ky = target['key']
                    let rl = reflect[ky]
                    if(data.data[rl] == 0){
                        router.replace({
                            "path":`/auth/${ky}`,
                            "query":{
                                "pid": route.value.query.pid,
                                "step": i + 1,
                                "as": verifyArray.length
                            }
                        })
                        compelete = false
                        break
                    }
                }
                if(compelete) {
                    // if(prodcut_ids.indexOf(parseInt(route.value.query.pid)) == -1) {
                    //     router.replace({
                    //         "path":`/`
                    //     })    
                    // } else {
                        
                    // }
                    router.replace({
                            "path":`/product/${route.value.query.pid}/detail`
                    })
                    
                }
            } else {
                loader.hide()
                proxy.$toast.show(data.msg)
            }
            
        })
    }
}
</script>